// Svelte 5 no longer needs svelte/store imports for basic reactivity

// Create reactive state for markers
export const markerState = $state({
    selected: 0,
    lists: [
        {
            id: '0',
            name: "Shot Changes",
            color: "#E74C3C",
            markers: []
        }
    ]
});

// Add a reset function to properly reset the state without reassignment
export function resetMarkerState() {
    markerState.selected = 0;
    markerState.lists = [
        {
            id: '0',
            name: "Shot Changes",
            color: "#E74C3C",
            markers: []
        }
    ];
}

// Custom reset that allows preserving the structure but with specified values
export function resetMarkerStateWithData(data) {
    if (!data) {
        resetMarkerState();
        return;
    }
    
    markerState.selected = data.selected || 0;
    markerState.lists = data.lists || [
        {
            id: '0',
            name: "Shot Changes",
            color: "#E74C3C",
            markers: []
        }
    ];
}